module.exports = __webpack_public_path__ + "img/s2.af5d2bc.png";